export const ProductMixins = {
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
    sizes: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      size: this.value,
    };
  },
  watch: {
    value() {
      this.size = this.value;
    },
  },
  updated() {
    if (this.sizes.length !== 0 && (!this.value || !this.sizes?.[this.value]?.inStock)) {
      const filterSizes = Object.entries(this.sizes).filter(([, sizeDetails]) => sizeDetails?.inStock),
        onlyOneSizeAvailable = filterSizes.length == 1;
      if (onlyOneSizeAvailable) {
        this.setSize(filterSizes?.[0]?.[0]);
      } else {
        this.setSize(Object.keys(this.sizes)?.find((sizeKey) => this.sizes[sizeKey]?.inStock) || '');
      }
    }
  },
  methods: {
    setSize(size) {
      if (size === this.size) {
        return;
      } else {
        this.size = size;
      }
      this.$emit('input', this.size);
    },
    isOutOfStock(sizeDetails) {
      return Boolean(!sizeDetails?.inStock);
    },
  },
};
